import React, { useEffect, useState } from 'react';
import { ActivityTimelineProps } from "./ActivityTimeline.props";
import { Box, Tooltip, Typography } from "@mui/material";
import './ActivityTimeline.css';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BarChartComponent from "../BarChart/BarChartComponent";
import { TOOLTIP_MESSAGES } from "../../constants/constants";
const ActivityTimeline: React.FC<ActivityTimelineProps> = ({ text, data }) => {
  const [seriesChart, setSeriesChart] = useState<any>();
  const [xLabels, setXLabels] = useState<any[]>([]);

  const convertDataSeries = (seriesData: any) => {
    let xLabelMonths: any[] = [];
    // const colorsChart = ['#244B77', '#9FD8DB'];
    // const labelChart = ['Emails Reported', 'Courses Completed'];
    const labelMap: Record<string, string> = {
      "REPORT_EMAIL": "Emails Reported",
      "COMPLETE_LEARNING_COURSE": "Courses Completed",
    };
    const colorMap: Record<string, string> = {
      "REPORT_EMAIL": "#9FD8DB",
      "COMPLETE_LEARNING_COURSE": "#244B77",
    };
    const chartData = Object.entries(seriesData).reverse().map(([key, value]) => {
      const valueObj: Record<string, number> = value && typeof value === "object" ? (value as Record<string, number>) : {};
      const months = Object.keys(valueObj);
      const valuesArray = Object.values(valueObj);
      xLabelMonths = months.map((m) => m.slice(0, 3));

      return {
        data: valuesArray,
        label: labelMap[key] || key, 
        id: `${key.toLowerCase()}Id`,
        color: colorMap[key] || "#ccc",
      };
    });
    setSeriesChart((prev: any) => JSON.stringify(prev) === JSON.stringify(chartData) ? prev : chartData)
    setXLabels((prev: any) => JSON.stringify(prev) === JSON.stringify(xLabelMonths) ? prev : xLabelMonths)
  }

  useEffect(() => {
    if (typeof data === 'object' && Object.keys(data).length > 0) {
      convertDataSeries(data)
    } else {
      setSeriesChart([])
      setXLabels([]);
    }
  }, [data])

// find "nice number" of MUI type
  const niceNumber = (range: number): number => {
    const exponent = Math.floor(Math.log10(range));
    const fraction = range / Math.pow(10, exponent);

    let niceFraction: number;
    if (fraction <= 1) niceFraction = 1;
    else if (fraction <= 2) niceFraction = 2;
    else if (fraction <= 5) niceFraction = 5;
    else niceFraction = 10;

    return niceFraction * Math.pow(10, exponent);
  }

// function to create  4 tick "nice numbers"
  const getNiceTicks = (min: number, max: number, tickCount = 4): number[] => {
    const range = max - min;
    const rawStep = range / (tickCount - 1);
    const step = niceNumber(rawStep);
    const ticks: number[] = [];
    for (let i = 0; i < tickCount; i++) {
      ticks.push(min + step * i);
    }

    return ticks;
  }

  const updateYAxisConfig=(series:any)=>{
    const values = series || [];
    const allValues = values.flatMap((s:any) => s.data);
    const max = Math.max(...allValues);
    const min = Math.min(...allValues);
    const ticks = getNiceTicks(min, max);
    const yAxisConfig:any ={};

    if (max <= 3 ) {
      yAxisConfig['max'] = 3;
      yAxisConfig['tickMinStep'] = 1;
      yAxisConfig['tickNumber']= 4;
    } else {
      yAxisConfig['tickNumber'] = 4,
      yAxisConfig['tickValues'] = ticks,
      yAxisConfig['min'] =ticks[0],
      yAxisConfig['max'] = ticks[ticks.length - 1],
      yAxisConfig['valueFormatter'] = (v:any) => `${Math.round(v)}`
    }

    return yAxisConfig
  }

  return (
    <>
      <div className={'activity-timeline'}>
        <Box width={'100%'} mb={'37px'}>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography sx={{ fontFamily: 'Righteous', fontSize: 24, fontWeight: 400, color: '#193051' }}>Activity
              Timeline</Typography>
            <Typography>
              <Tooltip
                title={TOOLTIP_MESSAGES.PROFILE_ACTIVITY_TIMELINE}
                placement="top-start"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '13px',
                      [`&.MuiTooltip-tooltipPlacementTop`]: {
                        maxWidth: 'fit-content',
                      },
                    },
                  },
                }}
              >
                <InfoOutlinedIcon sx={{ position: "relative", top: "4px", cursor: "pointer" }} fontSize={"medium"}
                  htmlColor={"#193051"} />
              </Tooltip>
            </Typography>
          </Box>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography sx={{
              fontFamily: 'Montserrat',
              fontSize: 16,
              fontWeight: 500,
              color: '#000000',
              opacity: 0.6,
              marginTop: '12px'
            }}>
              {text}
            </Typography>
          </Box>
        </Box>
        <div className={'activity-timeline-content'}>
          <BarChartComponent series={seriesChart} xLabels={xLabels} yAxisConfig ={updateYAxisConfig(seriesChart)} />
        </div>
      </div>
    </>
  );
};

export default ActivityTimeline;
